import './home.css'
import adblogo from '../assets/logos/ADB_logoBLUE.png'
import EAKPF from '../assets/logos/EAKPF-logo-FA-01-220x124.png'
import HLTF from '../assets/logos/HLT.png'
import BAP from '../assets/logos/BAPPENAS-LOGO-BARU-1.png'
import BRIN from '../assets/logos/Logo_of_National_Research_and_Innovation_Agency_of_Indonesia.svg_.png'
import CCDT from '../assets/logos/CCDTLogo.png'
import { Divider } from 'antd'
import logo from '../assets/mindearthlogo.png'
import AIT from '../assets/logos/AIT_logo.png'

export function Home() {
    return (
        <div className="centerBox centerHomeBox">
            <div className='opacityLayer'></div>
            <div className="homeContainer">
                <h3>Welcome to Geodigital Portal</h3>
                <p>A responsive Digital Twin to seamlessly visualize, explore, and combine geospatial information across Sumatra, Java and Bali.<br/><br/>This platform supports disaster-resilient wide-area planning considering potential carbon neutrality pathways.<br /><br />For optimum performance, a minimum of 30Mb/s internet connection is required.</p>
                <Divider />
                <p className='logo-description'>Key stakeholders:</p>
                <div className='logos'>
                    <a href='https://www.adb.org/' target="_blank" className='link'>
                        <img src={adblogo} alt="adblogo" className='logo' />
                    </a>
                    <a className='link'>
                        <img src={CCDT} alt="CCDT" className='logo' />
                    </a>
                    <a className='link'>
                        <img src={EAKPF} alt="EAKPF" className='logo' />
                    </a>
                    <a className='link'>
                        <img src={HLTF} alt="HLTF" className='logo' />
                    </a>
                    <a className='link'>
                        <img src={BAP} alt="BAP" className='logo' />
                    </a>
                    <a href='https://www.brin.go.id/en' className='link' target='_blank'>
                        <img src={BRIN} alt="BRIN" className='logo' />
                    </a>
                </div>
                <Divider />
                <div className='powered-row'>
                    <div className='powered-item'>
                        <p className='logo-description'>Hosted by:</p>
                        <a href='https://www.ait.ac.th/' target="_blank" className='logo-powered'>
                            <img src={AIT} alt="aitlogo" className='logo' />
                        </a>
                    </div>
                    <div className='powered-item'>
                        <p className='logo-description'>Developed by:</p>
                        <a href='https://mindearth.ai/' target="_blank" className='logo-designed'>
                            <img src={logo} alt="mindearthlogo" className='logo' />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )

}